/* RESTAURENTA HÉROS v3 (10/10/2026) : échelle de la scène, relief à la souris (bureau), onglets
   Attirer / Convertir / Rentabiliser, bouton pause, pause automatique hors écran et onglet caché.
   Aucun texte SEO modifié : les onglets ne changent que la carte conseil et la légende. */
(function(){
  'use strict';
  var root = document.documentElement;
  var scene = document.getElementById('rt-hero3-scene');
  var comp = document.getElementById('rt-hero3-comp');
  if (!scene || !comp) return;
  var hero = scene.closest('.rt-hero3');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(pointer: fine)');
  var motionBtn = hero.querySelector('.rt-hero3__motion');
  var paused = false, frame = 0;

  /* échelle : la composition est dessinée en 640 x 590 puis réduite à la largeur disponible */
  var resize = function(){ scene.style.setProperty('--scene-scale', String(scene.clientWidth / 640)); };
  resize();
  if ('ResizeObserver' in window) new ResizeObserver(resize).observe(scene); else window.addEventListener('resize', resize, { passive: true });

  /* relief à la souris (bureau seulement) */
  var resetTilt = function(){ cancelAnimationFrame(frame); hero.style.setProperty('--rx', '0deg'); hero.style.setProperty('--ry', '0deg'); };
  scene.addEventListener('pointermove', function(ev){
    if (paused || reduced.matches || !fine.matches || ev.pointerType === 'touch') return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function(){
      var box = scene.getBoundingClientRect();
      hero.style.setProperty('--ry', (((ev.clientX - box.left) / box.width - .5) * 8).toFixed(2) + 'deg');
      hero.style.setProperty('--rx', (-((ev.clientY - box.top) / box.height - .5) * 6).toFixed(2) + 'deg');
    });
  }, { passive: true });
  scene.addEventListener('pointerleave', resetTilt, { passive: true });

  /* bouton pause */
  if (motionBtn) motionBtn.addEventListener('click', function(){
    paused = !paused;
    root.classList.toggle('rth3-paused', paused);
    motionBtn.setAttribute('aria-pressed', String(paused));
    var label = paused ? 'Relancer les animations' : 'Mettre les animations en pause';
    motionBtn.setAttribute('aria-label', label); motionBtn.title = label;
    var use = motionBtn.querySelector('use'); if (use) use.setAttribute('href', paused ? '#rth3-play' : '#rth3-pause');
    resetTilt();
  });

  /* pause quand l'onglet est caché ou le héros hors écran */
  document.addEventListener('visibilitychange', function(){ root.classList.toggle('rth3-hidden', document.hidden); if (document.hidden) resetTilt(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries){ var e = entries[0]; root.classList.toggle('rth3-away', !e.isIntersecting); if (!e.isIntersecting) resetTilt(); }, { threshold: .05 }).observe(scene);
  }
  if (reduced.addEventListener) reduced.addEventListener('change', resetTilt);

  /* onglets */
  var content = {
    menu: ['Donnez envie, au premier regard.', 'Photos et menu font la différence.', 'Des visuels appétissants. Un menu qui donne envie de commander.'],
    conversion: ['Du clic à la commande.', 'Un menu clair. Un choix plus simple.', 'Produits, prix et promotions : chaque détail facilite le choix.'],
    performance: ['Chaque euro compte.', 'La marge guide les décisions.', 'Vos chiffres deviennent des décisions pour votre restaurant.']
  };
  var tabs = Array.prototype.slice.call(hero.querySelectorAll('.rt-hero3__tabs [role="tab"]'));
  var caption = document.getElementById('rt-hero3-caption');
  var iTitle = document.getElementById('rt-hero3-insight-title'), iText = document.getElementById('rt-hero3-insight-text');
  var select = function(tab){
    tabs.forEach(function(t){ var on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
    scene.setAttribute('data-focus', tab.getAttribute('data-mode'));
    var c = content[tab.getAttribute('data-mode')];
    if (c) { if (iTitle) iTitle.textContent = c[0]; if (iText) iText.textContent = c[1]; if (caption) { caption.textContent = c[2]; caption.setAttribute('aria-labelledby', tab.id); } }
  };
  tabs.forEach(function(tab, i){
    tab.addEventListener('click', function(){ select(tab); });
    tab.addEventListener('keydown', function(ev){
      var next = null;
      if (ev.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      if (ev.key === 'ArrowLeft') next = tabs[(i + tabs.length - 1) % tabs.length];
      if (ev.key === 'Home') next = tabs[0];
      if (ev.key === 'End') next = tabs[tabs.length - 1];
      if (next) { ev.preventDefault(); select(next); next.focus(); }
    });
  });
})();
